import { useGeneralStore } from 'src/stores'
import { reactive, watch } from 'vue'
const format = require('string-kit').format

export default function translate(translateObject) {
  const generalStore = useGeneralStore()

  const state = reactive({ language: generalStore.language })

  watch(
    () => generalStore.language,
    () => (state.language = generalStore.language),
  )

  /**
   * @param {string} text
   * @param {string[]} args
   * @return {*}
   */
  const argumentT = (text, args) => {
    if (!args.length) return text
    return format(text, ...args)
  }

  /**
   * @param {Record<string, any>} translateObject This is translate object using for generate translation
   * @param {string} translateNestedKey This is dot separated translation like 'user.address.line1'
   * @param {string[]} args - For replace args you have to use %s inside your translate
   */
  const t = (translateNestedKey, args = []) => {
    const keys = translateNestedKey.split('.')
    const result = keys.reduce((prev, curr) => {
      return prev ? prev[curr] : null
    }, translateObject)

    if (!result || !result[state.language]) {
      if (result?.en) return argumentT(result.en, args)
      else return translateNestedKey
    }

    return argumentT(result[state.language], args)
  }

  return { state, t }
}
